import
    React
    , {
          useRef
        , useState
        //, useCallback
        //, useEffect
    } from "react";

import {
      useNavigate
    , useLocation
    //, useParams
    , Link
} from 'react-router-dom';

import cn from "classnames";

//import { replaceSpacesWithHyphens } from '../../utils/formatPricingNumber';
import Icon from "../Icon";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const Register = props => {
//export default Register = props => {
    console.warn('Register()', props);


    /*
    */
    let index = props.index;
    let assetObject = props.assetObject;
    let categoryName = props.categoryName;
    let clickSearchResult = props.clickSearchResult;
    let handleCloseRegisterDialog = props.handleCloseRegisterDialog;
    //let keyDownUsername = props.keyDownUsername;
    //let keyDownPassword = props.keyDownPassword;
    let usernameRef = props.usernameRef;
    //let passwordRef = props.passwordRef;
    let registerPasswordRef = props.registerPasswordRef;
    let repeatPasswordRef = props.repeatPasswordRef;
    let firstNameRef = props.firstNameRef;
    let lastNameRef = props.lastNameRef;
    let emailRef = props.emailRef;
    let isAgreeTerms = props.isAgreeTerms;
    let isAgreeTermsRef = props.isAgreeTermsRef;
    let handleChangeAgreeTerms = props.handleChangeAgreeTerms;

    let isConsentToReceiveTextMessages = props.isConsentToReceiveTextMessages;
    let isConsentToReceiveTextMessagesRef = props.isConsentToReceiveTextMessagesRef;
    let handleChangeConsentToReceiveTextMessages = props.handleChangeConsentToReceiveTextMessages;

    let handleLogin = props.handleLogin;
    let registerError = props.registerError;
    let registerObject = props.registerObject;
    let handleChangeRegisterPassword = props.handleChangeRegisterPassword;
    //let clickForgotPassword = props.clickForgotPassword;
    //let clickRegister = props.clickRegister;

    const [registerPasswordVisibility, setRegisterPasswordVisibility] = useState(false);
    const [repeatRegisterPasswordVisibility, setRepeatRegisterPasswordVisibility] = useState(false);

    const handleChangeRegisterPasswordVisibility = () => {
        setRegisterPasswordVisibility(!registerPasswordVisibility);
    };

    const handleChangeRepeatRegisterPasswordVisibility = () => {
        setRepeatRegisterPasswordVisibility(!repeatRegisterPasswordVisibility);
    };

    return (

        <>

        <form
            ref = { props.registerFormRef }
            style = {{ width: '100%' }}
            >

        <div>

            {
                props.showCloseButton
                && <div
                    style = {{
                          textAlign: 'right'
                        , marginRight: '0'
                        , position: 'relative'
                        //, border: 'blue 3px solid'
                    }}
                    >
                    <button
                        //className = { styles.close }
                        className = 'close'
                        onClick = { handleCloseRegisterDialog }
                        style = {{
                            position: 'absolute'
                            //, border: 'green 3px solid'
                        }}
                        >
                        <Icon name="close" size="14" />
                    </button>
                </div>
            }

            <h3
                style = {{ 
                      textAlign: 'left'
                    , fontSize: '40px'
                    , fontWeight: 600
                }}
                >
                Register
            </h3>

            <div className = { "editable" } style = {{ marginBlock: 20 }}>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "input-box" } style = {{ marginBottom: 8 }}>
                        <input
                            type = "text"
                            name = "firstName"
                            ref = { firstNameRef }
                            style = {{ width: '100%' }}
                            placeholder = "First Name"
                            />
                    </div>
                    <div>
                        {
                            registerError?.firstName
                            && <div
                                className = 'error-msg'
                                >{ registerError?.firstName }</div>
                        }
                    </div>
                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "input-box"} style = {{ marginBottom: 8 }}>
                        <input
                            type = "text"
                            name = "lastName"
                            ref = { lastNameRef }
                            style = {{ width: '100%' }}
                            placeholder = "Last Name"
                            />
                    </div>
                    <div>
                        {
                            registerError?.lastName
                            && <div
                                className = 'error-msg'
                                >{ registerError?.lastName }</div>
                        }
                    </div>
                </div>
                
                <div style = {{ marginBottom: 8 }}>
                    <div className = { "input-box"}>
                        <input
                            type = "text"
                            name = "username"
                            //value = 'service.account@wearefuturetech.com'
                            ref = { emailRef }
                            style = {{ width: '100%' }}
                            placeholder = "name@email.com"
                            onKeyDown = {(e) => props.keyDownUsername(e)}
                            value =  { registerObject?.username }
                            onChange = { handleChangeRegisterPassword }
                            />
                    </div>
                    <div>
                        {
                            registerError?.username
                            && <div
                                //className = { styles.errorMsg }
                                className = 'error-msg'
                                >{ registerError?.username }</div>
                        }
                    </div>
                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "input-box"}>
                        <input
                            type = "text"
                            name = "phone"
                            //value = 'service.account@wearefuturetech.com'
                            //ref = { emailRef }
                            style = {{ width: '100%' }}
                            placeholder = "Phone"
                            //onKeyDown = {(e) => props.keyDownUsername(e)}
                            value =  { registerObject?.phone }
                            //onChange = { handleChangeRegisterPhone }
                            />
                    </div>
                    <div>
                        {
                            registerError?.phone
                            && <div
                                //className = { styles.errorMsg }
                                className = 'error-msg'
                                >{ registerError?.phone }</div>
                        }
                    </div>
                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "input-box" }>
                        <input
                            type = { registerPasswordVisibility ? "text" : "password" }
                            ref = { registerPasswordRef }
                            style = {{ width: '100%' }}
                            //name = "registerpassword"
                            name = "password"
                            onChange = { handleChangeRegisterPassword }
                            //value = ''
                            //value =  { registerObject?.registerpassword }
                            value =  { registerObject?.password }
                            //placeholder="**********"
                            placeholder="Enter a password"
                            onKeyDown={(e) => props.keyDownPassword(e)}
                            />
                            {
                                registerPasswordVisibility
                                ? (
                                    <VisibilityIcon
                                        style={{ margin: "0px 8px 0px -32px" }}
                                        onClick={() => handleChangeRegisterPasswordVisibility()}
                                        />
                                ) : (
                                    <VisibilityOffIcon
                                        style={{ margin: "0px 8px 0px -32px" }}
                                        onClick={() => handleChangeRegisterPasswordVisibility()}
                                        />
                                )
                            }
                    </div>

                    <div>
                        {
                            registerError?.password
                            && <div
                                className = 'error-msg'
                                >{ registerError?.password }</div>
                        }
                    </div>
                </div>

                <div
                    style = {{ marginBottom: 8 }}
                    >

                    <div className = { "input-box" } style={{marginTop: 8}}>
                        <input
                            //type = "password"
                            type = { repeatRegisterPasswordVisibility ? "text" : "password" }
                            ref = { repeatPasswordRef }
                            style = {{ width: '100%' }}
                            name = "repeatpassword"
                            value =  { registerObject?.repeatpassword }
                            onChange = { handleChangeRegisterPassword }
                            //onChange = { handleChangeRepeatPassword }
                            //value = ''
                            //placeholder = "**********"
                            placeholder="Repeat the password"
                            //onKeyDown={(e) => keyDownPassword(e)}
                            />
                            {
                                repeatRegisterPasswordVisibility
                                ? (
                                    <VisibilityIcon
                                        style={{ margin: "0px 8px 0px -32px" }}
                                        onClick={() => handleChangeRepeatRegisterPasswordVisibility()}
                                        />
                                ) : (
                                    <VisibilityOffIcon
                                        style={{ margin: "0px 8px 0px -32px" }}
                                        onClick={() => handleChangeRepeatRegisterPasswordVisibility()}
                                        />
                                )
                            }
                    </div>
                    <div>
                        {
                            registerError?.repeatpassword
                            && <div
                                className = 'error-msg'
                                >{ registerError?.repeatpassword }</div>
                        }
                    </div>
                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "table" } style = {{ maxWidth: "600px", margin: "10px auto 5px auto" }}>
                        <div className = { "row" }>
                            <div className = { "cell" }>
                                <input
                                    type = "checkbox"
                                    id = "agree_terms"
                                    name = "agree_terms"
                                    ref = { isAgreeTermsRef }
                                    value = { isAgreeTerms }
                                    onChange = { handleChangeAgreeTerms }
                                    //onChange = () => { setIsAgreeTerms(this.value) }
                                    //onChange = { () => setIsAgreeTerms(this.value) }
                                    style = {{
                                          verticalAlign: "middle"
                                        , border: "2px solid #E6E8EC"
                                        , borderRadius: "5px"
                                        //, width: '30px'
                                        //, height: '30px'
                                    }}
                                    />
                            </div>
                            <div className = { "cell" }>
                                <label
                                    for = "agree_terms"
                                    className = 'consent-text'
                                    style = {{
                                        paddingLeft: "10px"
                                        , userSelect: "none"
                                        , paddingBottom: "0px"
                                        //, fontSize: ".9em"
                                        , display: 'block'
                                    }}
                                    >
                                    By clicking here you understand and agree our <Link to="/terms-and-conditions" target = '_blank'>Terms of Service</Link> and to our <Link to="/privacy-policy" target = 'new'>Privacy Policy</Link>.
                                    Please read these carefully before using the Site.
                                </label>
                            </div>
                        </div>

                    </div>

                    <div>
                        {
                            registerError?.agree_terms
                            && <div
                                className = 'error-msg'
                                >{ registerError?.agree_terms }</div>
                        }
                    </div>

                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "table" } style = {{ maxWidth: "600px", margin: "10px auto 5px auto" }}>
                        <div className = { "row" }>
                            <div className = { "cell" }>
                                <input
                                    type = "checkbox"
                                    id = "consent-to-receive-marketing-messages"
                                    name = "consent-to-receive-marketing-messages"
                                    //ref = { isConsentToReceiveTextMessagesRef }
                                    value = { isConsentToReceiveTextMessages }
                                    onChange = { handleChangeConsentToReceiveTextMessages }
                                    style = {{
                                          verticalAlign: "middle"
                                        , border: "2px solid #E6E8EC"
                                        , borderRadius: "5px"
                                        //, width: '30px'
                                        //, height: '30px'
                                    }}
                                    />
                            </div>
                            <div className = { "cell" }>
                                <label
                                    for = "consent-to-receive-marketing-messages"
                                    className = 'consent-text'
                                    style = {{
                                        paddingLeft: "10px"
                                        , userSelect: "none"
                                        , paddingBottom: "0px"
                                        //, fontSize: ".9em"
                                        , display: 'block'
                                    }}
                                    >
                                    I consent to receive marketing text messages from RealSplit at the phone number provided.
                                    Frequency may vary.
                                    Message and data rates may apply.
                                    Type HELP for assistance. Type STOP to opt out.
                                </label>
                            </div>
                        </div>

                    </div>
                </div>

                <div style = {{ marginBottom: 8 }}>
                    <div className = { "table" } style = {{ maxWidth: "600px", margin: "10px auto 5px auto" }}>
                        <div className = { "row" }>
                            <div className = { "cell" }>
                                <input
                                    type = "checkbox"
                                    id = "consent-to-receive-non-marketing-messages"
                                    name = "consent-to-receive-non-marketing-messages"
                                    //ref = { isConsentToReceiveTextMessagesRef }
                                    value = { isConsentToReceiveTextMessages }
                                    onChange = { handleChangeConsentToReceiveTextMessages }
                                    style = {{
                                          verticalAlign: "middle"
                                        , border: "2px solid #E6E8EC"
                                        , borderRadius: "5px"
                                        //, width: '30px'
                                        //, height: '30px'
                                    }}
                                    />
                            </div>
                            <div className = { "cell" }>
                                <label
                                    for = "consent-to-receive-non-marketing-messages"
                                    className = 'consent-text'
                                    style = {{
                                        paddingLeft: "10px"
                                        , userSelect: "none"
                                        , paddingBottom: "0px"
                                        //, fontSize: ".9em"
                                        , display: 'block'
                                    }}
                                    >
                                    I consent to receive non-marketing text messages from RealSplit about my order updates, appointment reminders etc.
                                    Message & data rates map apply.
                                </label>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {/*
                !isRegisteredUser

                ? <button
                    className = 'primary'
                    style = {{ marginBottom: 10 }}
                    onClick = { registerUser }
                    >
                    <span>Continue</span>
                </button>

                : <button
                    className = 'primary'
                    style = {{ marginBottom: 10 }}
                    onClick = { handleLogin }
                    >
                    <span>Save Password</span>
                </button>

            <input
                type= 'submit'
                className = 'button primary'
                style = {{ marginBottom: 10, marginRight: 10 }}
                //onClick = { props.registerUser }
                onClick = { (event) => props.registerUser(event) }
                value = 'Submit'
                />
            */}

            <button
                className = 'primary'
                style = {{ marginBottom: 10 }}
                //onClick = { props.registerUser }
                onClick = { (event) => props.registerUser(event) }
                >
                Continue
            </button>

            {
                props.isModal
                && <button
                    //className="button-login button large rounded transparent"
                    //className = 'theme-cancel large rounded transparent'
                    //className = 'theme-cancel large'
                    className = 'primary-inverse large'
                    style = {{ marginLeft: '20px' }}
                    onClick = { handleCloseRegisterDialog }
                    >
                    <span>Cancel</span>
                </button>
            }

        </div>

        <div style = {{ paddingTop: '18px' }}>
            <div
                style = {{ paddingRight: '20px', fontSize: '.9em' }}
                >
                Already a member? <Link
                    to = '/login'
                    //className = 'theme-primary rounded medium'
                    //className = 'primary-inverse rounded medium'
                    //className = 'link'
                    //style = {{ marginLeft: '20px' }}
                    style = {{
                        textDecoration: 'underline'
                        , fontSize: '1.2em'
                        , paddingLeft: '8px'
                    }}
                    //onClick = { props.showLoginDialog }
                    onClick = { handleCloseRegisterDialog }
                    >
                    Log In
                </Link>
            </div>
            {/*
            <button
                //className = 'theme-primary rounded medium '
                className = 'primary-inverse rounded medium '
                //className = 'link'
                //style = {{ marginLeft: '20px' }}
                style = {{
                    padding: '10px 20px'
                }}
                //onClick = { clickForgotPassword }
                //onClick = { clickForgotPassword }
                onClick = { props.showLoginDialog }
                >
                <span>Log In</span>
            </button>
            */}
        </div>

        </form>

        </>
    );
}

export default Register;
